<template>
  <div class="table">
    <el-table
      row-key="id"
      :data="tableDataRule"
      stripe
      style="width: 100%"
      :header-cell-style="{background:'#EFEFEF'}"
    >
      <el-table-column
        v-for="(item,index) in tableLabel"
        :width="item.width ? item.width : ''"
        :key="index"
        :align="item.align"
        :label="item.label"
        :prop="item.param"
        :sortable="item.sortable ? 'custom' : false"
      >
        <template slot-scope="scope">
          <span v-if="item.render">
            {{item.render(scope.row)}}
          </span>
          <span v-else>{{scope.row[item.param]}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
export default {
  props: {
    tableDataRule: {
      type: Array,
    },
    tableLabel: {
      type: Array,
    },
  },
  data() {
    return {
      //tableDataRule: [
      //   {
      //     integralName: "长啥",
      //     company: "xued",
      //     integralNum: "19d",
      //   },
      //   {
      //     integralName: "长啥",
      //     company: "xued",
      //     integralNum: "19d",
      //   },
      // ],
      // tableLabel: [
      //   { label: "类型", param: "integralName" },
      //   { label: "积分", param: "integralNum" },
      //   // { label: "用户名", param: "usr", align: "center" },
      //   // { label: "公司名称", param: "company", align: "center" },
      //   // { label: "办公邮箱", param: "email", align: "center", width: "200" },
      // ],
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.table {
  /deep/.el-table td {
    .el-table th {
      padding: 7px 20px;
    }
  }
}
</style>
